// Module
var code = `<h1><span>STAGE:</span> {{title}}</h1>
`;
// Exports
module.exports = code;